/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import React from 'react';
import { Color, FontSize } from 'views/constants';

const base = css`
  text-decoration: inherit;
  margin: 0;
  word-break: break-word;
`;

type TypographyType =
  | 'span'
  | 'p'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'sup'
  | 'sub'
  | 'small';

interface TypographyProps {
  el?: TypographyType;
  color?: Color | 'inherit';
  // line-height に対してどのくらいルール化されるかわからなかったので、 string としています。
  lineHeight?: string | 'inherit';
  size?: FontSize;
  role?: string;
  block?: boolean;
  bold?: boolean;
  ellipsis?: boolean;
  preWrap?: boolean;
}

export const Typography: React.FC<
  TypographyProps &
    React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLSpanElement>,
      HTMLSpanElement
    >
> = ({
  el: Element = 'span',
  color = Color.C1,
  lineHeight = 'inherit',
  size = FontSize.DEFAULT,
  role,
  block,
  bold,
  ellipsis,
  children,
  preWrap,
}) => {
  const ellipsisStyle = ellipsis
    ? css`
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      `
    : null;
  const whiteSpace =
    // ellipsisが優先
    !ellipsis && preWrap
      ? css`
          white-space: pre-wrap;
        `
      : null;
  const style = css`
    ${base};
    color: ${color};
    text-decoration-color: ${color};
    font-size: ${size};
    display: ${block ? 'block' : 'inline-block'};
    font-weight: ${bold ? 'bold' : 'normal'};
    line-height: ${lineHeight ? lineHeight : 'inherit'};
    ${ellipsisStyle};
    ${whiteSpace}
  `;

  return (
    <Element css={style} role={role}>
      {children}
    </Element>
  );
};
